import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';


@Injectable()
export class exportExcelService {

    SalvarArquivo(divName, titulo) {

        var elt = document.getElementById(divName);
        var wb = XLSX.utils.table_to_book(elt, { cellDates: true, raw: true });
        XLSX.writeFile(wb, titulo + '.xlsx');
    }

  SalvarArquivoComAbas(divIds: string[], titulo: string) {
    let xml =
      `<?xml version="1.0"?>
      <?mso-application progid="Excel.Sheet"?>
      <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
                xmlns:o="urn:schemas-microsoft-com:office:office"
                xmlns:x="urn:schemas-microsoft-com:office:excel"
                xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">`;

    xml += `
      <Styles>
        <Style ss:ID="Header">
          <Font ss:Bold="1" ss:Color="#000000"/>
          <Interior ss:Color="#D9D9D9" ss:Pattern="Solid"/>
          <Alignment ss:Vertical="Center" ss:WrapText="0"/>
          <Borders>
            <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Left"   ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Right"  ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Top"    ss:LineStyle="Continuous" ss:Weight="1"/>
          </Borders>
        </Style>

        <Style ss:ID="DefaultCell">
          <Alignment ss:Vertical="Center" ss:WrapText="0"/>
          <Borders>
            <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Left"   ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Right"  ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Top"    ss:LineStyle="Continuous" ss:Weight="1"/>
          </Borders>
        </Style>

        <!-- Estilo Moeda (R$) -->
        <Style ss:ID="CurrencyCell">
          <NumberFormat ss:Format="[$R$-416]\ #,##0.00"/>
          <Alignment ss:Vertical="Center" ss:WrapText="0"/>
          <Borders>
            <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Left"   ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Right"  ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Top"    ss:LineStyle="Continuous" ss:Weight="1"/>
          </Borders>
        </Style>

        <!-- Estilo Data -->
        <Style ss:ID="DateCell">
          <NumberFormat ss:Format="dd/mm/yyyy;@"/>
          <Alignment ss:Vertical="Center" ss:WrapText="0"/>
          <Borders>
            <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Left"   ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Right"  ss:LineStyle="Continuous" ss:Weight="1"/>
            <Border ss:Position="Top"    ss:LineStyle="Continuous" ss:Weight="1"/>
          </Borders>
        </Style>
      </Styles>`;

    divIds.forEach((divId, index) => {
      const div = document.getElementById(divId);
      if (!div) return;

      const table = div.querySelector('table');
      if (!table) return;

      const sheetName = this.nomeSheet(divId, index);
      xml += `<Worksheet ss:Name="${sheetName}"><Table>`;

      const rows = Array.from(table.querySelectorAll('tr'));
      const maxLengths: number[] = [];

      rows.forEach(row => {
        const cells = Array.from(row.querySelectorAll('th, td'));
        cells.forEach((cell, colIndex) => {
          const textLength = (cell.textContent || '').trim().length;
          if (!maxLengths[colIndex] || textLength > maxLengths[colIndex]) {
            maxLengths[colIndex] = textLength;
          }
        });
      });

      maxLengths.forEach(len => {
        const width = Math.max(60, Math.min(400, len * 8));
        xml += `<Column ss:Width="${width}"/>`;
      });

      rows.forEach(row => {
        xml += `<Row>`;
        const cells = row.querySelectorAll('th, td');
        cells.forEach(cell => {
          const raw = (cell.textContent || '').trim();
          const isHeader = cell.tagName.toLowerCase() === 'th';

          if (isHeader) {
            xml += `<Cell ss:StyleID="Header"><Data ss:Type="String">${this.escapeXml(raw)}</Data></Cell>`;
            return;
          }

          // Detecta tipo e gera célula adequada
          const { type, style, value } = this.detectType(raw);
          xml += `<Cell ss:StyleID="${style}"><Data ss:Type="${type}">${this.escapeXml(value)}</Data></Cell>`;
        });
        xml += `</Row>`;
      });

      xml += `</Table></Worksheet>`;
    });

    xml += `</Workbook>`;

    const blob = new Blob([xml], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${titulo}.xls`;
    link.click();
  }

  // Detecta o tipo da célula e retorna estilo + valor normalizado
  private detectType(raw: string): { type: string; style: string; value: string } {

    // --- Moeda: começa com R$, ou padrão 1.234,56 ---
    const moedaRegex = /^R\$\s*([\d.,]+)|^([\d]{1,3}(?:\.\d{3})*,\d{2})$/;
    if (moedaRegex.test(raw)) {
      const numStr = raw
        .replace(/R\$\s*/, '')   // remove prefixo R$
        .replace(/\./g, '')       // remove separador de milhar
        .replace(',', '.');       // troca vírgula decimal por ponto
      const num = parseFloat(numStr);
      if (!isNaN(num)) {
        return { type: 'Number', style: 'CurrencyCell', value: String(num) };
      }
    }

    // --- Data: dd/mm/aaaa ou dd-mm-aaaa ---
    const dataISORegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
    const dataISOMatch = raw.match(dataISORegex);
    if (dataISOMatch) {
      // Se for a data padrão "vazia", retorna célula em branco
      if (dataISOMatch[1] === '1950' && dataISOMatch[2] === '01' && dataISOMatch[3] === '01') {
        return { type: 'String', style: 'DefaultCell', value: '' };
      }

      const iso = `${dataISOMatch[1]}-${dataISOMatch[2]}-${dataISOMatch[3]}T${dataISOMatch[4]}:${dataISOMatch[5]}:${dataISOMatch[6]}`;
      return { type: 'DateTime', style: 'DateCell', value: iso };
    }

    // --- Fallback: texto ---
    return { type: 'String', style: 'DefaultCell', value: raw };
  }

  // 🔹 Escapa caracteres especiais XML
  private escapeXml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  private nomeSheet(divId: string, index: number): string {
    // Define um nome de aba legível baseado no ID
    const nome = divId.replace(/[-_]/g, ' ');
    return nome.charAt(0).toUpperCase() + nome.slice(1) || `Aba ${index + 1}`;
  }

    constructor() {

    }
}
